import Vue from 'vue';
import users from '../../../users';
import axios from 'axios';
import moment from 'moment';
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager,
  DxColumnFixing,
  DxLookup,
  DxFormat
} from 'devextreme-vue/data-grid';

export default {
  name: 'Steps',
  components: {
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    DxColumnFixing,
    DxLookup,
    DxFormat,
    StepComp: require('./step.vue').default,
  },
  mixins: [users],
  props: ['dataObj'],
  data: function () {
    return {
      outcomes: [],
      allOutcomes: [],
      outcomeTypes: [],
      conditions: [],
      elementConditions: [],
      items: [],
      iJobCardId: -1,
      iStepId: -1,
      totalRow: 0,
      options: { pageSize: 10, total: 0, page: 1, filterText: null },
      bAutoExpand: true,
      bPageChange: true,
      bInlineEditing: true,
      editMode: 'row',
      filterBuilderPopupPosition: {
        of: window,
        at: 'top',
        my: 'top',
        offset: { y: 10 }
      },
      editButtons: [
        {
          hint: 'Edit',
          icon: 'edit',
          visible: true,
          onClick: this.editItem
        }
      ],
      setOutcomeValue(rowData, value) {
        rowData.outcomeId = null;
        this.defaultSetCellValue(rowData, value);
      },
      addingStep: {
        jobcardId: 0,
        StepId: 0,
        Name: '',
        Comment: '',
        ActualTime: '',
        OutcomeTypeId: 0,
        OutcomeId: 0,
        ItemSerialNo: '',
        ReadingDateTime: '',
        Reading: 0,
        ConditionId: 0,
        ConditionComment: ''
      },
      bAddStep: false,
    }
  },
  computed: {
    toDate: function () {
      return this.options.to;
    }
  },
  watch: {
    bInlineEditing: function (value) {
      this.editMode = value === true ? 'row' : 'popup';
    },
    iJobCardId: function (value) {
      if (value > -1) {
        var parameter = {
          jobcardId: this.iJobCardId,
          options: this.options
        };
        this.get(parameter);
      }
    },
  },
  created() {
    this.getLookups();
    this.init();
    //this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.iJobCardId = this.dataObj.id;
      });
    },
    pageChange(pInfo) {
      if (this.bPageChange === true)
        this.bPageChange = false
      else
        if (this.iJobCardId > -1) {
          this.options.pageSize = pInfo.pageSize;
          this.options.page = pInfo.pageNumber;
          var parameter = {
            jobcardId: this.iJobCardId,
            options: this.options
          };
          this.get(parameter);
        }
    },
    getLookups() {
      axios.post('/JobcardStep/GetLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.item.outcomes.forEach(item => {
              item.originalId = item.id;
              item.id = item.outcomeTypeId + '-' + item.id;
            });
            this.outcomes = response.data.item.outcomes;
            this.allOutcomes = response.data.item.outcomes;
            this.outcomeTypes = response.data.item.outcomeTypes;
            this.elementConditions = response.data.item.elementConditions;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getLookups');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    get(parameter) {
      this.$store.state.notifier.asyncBlock(
        axios.post('/JobcardStep/Get', parameter),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            response.data.items.forEach(item => {
              item.reading = item.reading === null ? '' : item.reading;
              item.originalOutcomeId = item.outcomeId;
              item.outcomeId = item.outcomeTypeId + '-' + item.outcomeId;
            });
            this.items = response.data.items;
            this.totalRow = response.data.count;
          }
          else {
            this.$alertMsg(response.data.data.text);
            this.totalRow = 0;
          }
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Steps '
      );
    },
    getFilteredOutcomes(value) {
      var rc = {
        store: this.allOutcomes,
        filter: value.data ? ['outcomeTypeId', '=', value.data.outcomeTypeId] : null
      };
      return rc;
    },
    getConditions(value) {
      var rc = {
        store: value.data ? this.elementConditions[value.data.elementTypeId] : this.elementConditions[0],
        filter: null
      };
      return rc;
    },
    gridEditorPreparing(value) {
      if (value.parentType === "dataRow") {
        switch (value.dataField) {
          case "stepId":
            value.editorOptions.readOnly = true;
            break;
          case "name":
            value.editorOptions.readOnly = value.row.data.isSystem === true;
            break;
          case "readingDateTime":
            value.editorOptions.readOnly = !(value.row.data.isSystem === true && value.row.data.hasReading === true);
            break;
          case "itemSerialNo":
            var outcomeId = value.row.data.outcomeId;
            var outcome = this.outcomes.filter(item => item.id === outcomeId) ? this.outcomes.filter(item => item.id === outcomeId).length > 0 ? this.outcomes.filter(item => item.id === outcomeId)[0] : null : null;
            value.editorOptions.readOnly = true;
            if (outcome !== null) {
              value.editorOptions.readOnly = !(value.row.data.isSystem === true && outcome.hasSerial === true);
            }
            break;
          case "outcomeTypeId":
            value.editorOptions.readOnly = !(value.row.data.isSystem === false && value.row.data.hasReading === true);
            break;
          case "conditionId":
            value.editorOptions.readOnly = !(value.row.data.elementTypeId > 0 && value.row.data.elementId > 0);   
            break;
          case "conditionComment":
            value.editorOptions.readOnly = !(value.row.data.elementTypeId > 0 && value.row.data.elementId > 0);
            break;
          default:
            // do nothing
        }
        //e.editorOptions.disabled = e.row.data && e.row.data.FirstName === "";
      }
    },
    gridEditingStart(value) {
      //console.log(value);
    },
    gridInitNewRow(value) {
      console.log('InitNewRow');
      console.log(value);
      axios.post('/JobcardStep/AddStep', { jobcardId: this.iJobCardId })
        .then(response => {
          if (response.data.data.status == 0) {
            var item = response.data.item;
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    gridRowInserting(value) {
      //console.log(value);
    },
    gridRowInserted(value) {
      //console.log(value);
    },
    gridRowUpdating(value) {
      //console.log(value);
    },
    gridRowUpdated(value) {
      //console.log(value);
      var rec = value.data;
      var outcomeId = rec.outcomeId.substring(rec.outcomeId.indexOf('-') + 1)

      var parameter = {
        jobcardId: rec.jobcardId,
        StepId: rec.stepId,
        Name: rec.name,
        Comment: rec.comment,
        ActualTime: rec.actualTime,
        OutcomeTypeId: rec.outcomeTypeId,
        OutcomeId: outcomeId,
        ItemSerialNo: rec.itemSerialNo,
        ReadingDateTime: moment(rec.readingDateTime),
        Reading: rec.reading,
        ConditionId: rec.conditionId,
        ConditionComment: rec.conditionComment
      };
      this.update(parameter);
    },
    gridRowRemoving(value) {
      this.$store.state.notifier.asyncBlock(
        axios.post('/JobcardStep/RemoveStep', { jobcardId: this.iJobCardId, stepId: value.key.stepId }),
        resp => {
          if (resp.status === 200 && resp.data.data.status === 0) {
            if (resp.data.data.status == 0) {
              this.$alertMsg(this.$t('messages.RecordRemovedSuccess'),2);
            }
            else {
              this.$alertMsg(resp.data.data.text);
            }            
          }
          else
            this.$alertMsg(resp.data.data.text)
          var parameter = {
            jobcardId: this.iJobCardId,
            options: this.options
          };
          this.get(parameter);
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        }
      );
    },
    gridRowRemoved(value) {
      console.log('removed');
      console.log(value);
    },
    gridRowSaving(value) {
      if (value.changes && value.changes.length > 0 && value.changes[0].type === 'remove' && value.changes[0].key.isSystem === true) {
        value.cancel = true;
        this.$alertMsg(this.$t('omApplication.CannotDeleteSystemStep'), 3);
      }
      //console.log('Saving');
      //console.log(value);
    },
    gridRowSaved(value) {
      console.log('Saved');
      console.log(value);
    },
    update(parameter) {
      this.$store.state.notifier.asyncBlock(
        axios.post('/JobcardStep/Update', parameter),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            var item = response.data.item;
            this.$alertMsg(this.$t('messages.RecordSavedSuccess'), 2);
          }
          else {
            this.$alertMsg(response.data.data.text);
            this.totalRow = 0;
          }
        },
        err => {
          this.$alertMsg(err.response.data);
        },
        'Updating Step'
      );
    },
    getItem() {
      var parameter = {
        jobcardId: this.iJobcardId,
        stepId: this.iStepId
      };
      axios.post('/JobcardStep/GetItem', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.warehousesSource = response.data.items;
            this.warehousesDestination = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getItem');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    editItem(item) {
      //console.log(item);
      //let id = app.row.data.sourceId;
      //let type = app.row.data.type;
      //var route = '/omApplication/' + type + '/' + id;
      //this.$router.push(route);
    },
    addStep() {
      this.addingStep.jobcardId = this.iJobCardId;
      this.addingStep.StepId = 0;
      this.addingStep.allOutcomes = this.allOutcomes;
      this.addingStep.outcomes = this.allOutcomes;
      this.addingStep.outcomeTypes = this.outcomeTypes;
      this.addingStep.conditions = this.elementConditions[0];

      this.$root.$emit('add_step_started');
      
      this.bAddStep = true;
    },
    saveStep() {
      axios.post('/JobcardStep/AddStep', { jobcardId: this.iJobCardId })
        .then(response => {
          if (response.status === 200 && response.data.data.status === 0) {
            var item = response.data.item;
            var outcomeId = this.addingStep.OutcomeId.substring(this.addingStep.OutcomeId.indexOf('-') + 1)

            var parameter = {
              JobcardId: this.addingStep.jobcardId,
              StepId: item.stepId,
              Name: this.addingStep.Name,
              Comment: this.addingStep.Comment,
              ActualTime: this.addingStep.ActualTime,
              OutcomeTypeId: this.addingStep.OutcomeTypeId,
              OutcomeId: outcomeId,
              ItemSerialNo: this.addingStep.ItemSerialNo,
              ReadingDateTime: moment(this.addingStep.ReadingDateTime),
              Reading: this.addingStep.Reading,
              ConditionId: this.addingStep.ConditionId,
              ConditionComment: this.addingStep.ConditionComment
            };
            this.$store.state.notifier.asyncBlock(
              axios.post('/JobcardStep/Update', parameter),
              response => {
                if (response.status === 200 && response.data.data.status === 0) {
                  var itemUpd = response.data.item;
                  this.$alertMsg(this.$t('messages.RecordSavedSuccess'), 2);
                  this.bAddStep = false;
                }
                else {
                  this.$alertMsg(response.data.data.text);
                  this.totalRow = 0;
                }
              },
              err => {
                this.$alertMsg(err.response.data);
                this.$router.push('/login');
              },
              'Updating Step'
            );
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    closeDialog() {
      this.bAddStep = false;
    },
  },
  
}

